

























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { deletePayment, getPayments, getCompanies } from '@/api/api';
import MetaDatatable from '../models/MetaDatatable';
import HeaderDatatable from '../models/HeaderDatatable';
import User from '../models/User';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import PaginationDatatable from '../models/PaginationDatatable';
import SorterDatatable from '../models/SorterDatatable';
import moment from 'moment';
import formatAmount from '../utils/formatAmount';
import Payment from '../models/Payement';
import Company from '../models/Company';
import { fetchPrescriber } from '@/utils/filters';
import FilterComponent from '@/components/FilterComponent.vue';
import Datatable from '@/components/Datatable.vue';
import cloneDeep from 'lodash/cloneDeep';

@Component({
    filters: {
        formatAmount,
    },
    components: {
        Datatable,
        FilterComponent,
    },
})
export default class Payments extends Vue {
    moment = moment;
    defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 20,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: {
            prescriber: undefined,
        },
    };
    meta: MetaDatatable = cloneDeep(this.defaultMeta);
    columns: HeaderDatatable[] = [
        {
            title: 'Prescripteur',
            dataIndex: 'subscription.prescriber',
            sorter: true,
            scopedSlots: {
                customRender: 'prescriber',
            },
        },
        {
            title: 'Montant',
            dataIndex: 'amount',
            sorter: true,
            scopedSlots: {
                customRender: 'amount',
            },
        },
        {
            title: 'Payé le',
            dataIndex: 'paid_at',
            scopedSlots: {
                customRender: 'paid_at',
            },
            sorter: true,
        },
        //        {
        //            title: 'Actions',
        //            dataIndex: 'action',
        //            scopedSlots: {
        //                customRender: 'actions',
        //            },
        //        },
    ];
    async fetch(meta: MetaDatatable) {
        const { data } = await getPayments({
            ...meta,
            page: meta.page - 1,
        });
        return data;
    }
    deleteText = {
        confirm: {
            title: `Suppression du paiment`,
            content: `Voulez-vous vraiment supprimer le paiement ?`,
        },
        notify: {
            title: 'Paiement supprimé',
            content: `Le paiement a bien été supprimé`,
        },
    };

    // Prescibers
    get fetchPrescriber() {
        return fetchPrescriber;
    }
    onFilterPrescriber(value: number | undefined) {
        this.meta.filters.prescriber = value;
    }

    async actionDatatable(ev: {
        action: 'show' | 'edit' | 'delete' | 'add';
        item?: Payment | null;
    }) {
        const action = ev.action;
        const payment: Payment | null = ev.item || null;
        switch (ev.action) {
            case 'edit':
                break;
            case 'delete':
                if (payment && payment.id) {
                    this.meta = {
                        total: this.meta.total || 0,
                        pages: this.meta.pages || 0,
                        page: this.meta.page || 0,
                        perPage: this.meta.perPage || 10,
                        search: this.meta.search || null,
                        orderBy: this.meta.orderBy || null,
                        orderWay: this.meta.orderWay || null,
                        filters: this.meta.filters || null,
                    };
                    await deletePayment(payment.id);
                }
                break;
        }
    }

    deleteDialog(payment: Payment) {
        const $vs = (this as any).$vs;
        $vs.dialog({
            type: 'confirm',
            color: 'success',
            title: this.deleteText.confirm.title,
            text: this.deleteText.confirm.content,
            accept: () => this.acceptDeleteAlert(payment),
            acceptText: 'Confirmer',
            cancelText: 'Annuler',
        });
    }

    async acceptDeleteAlert(payment: Payment) {
        const $vs = (this as any).$vs;
        try {
            await this.actionDatatable({ action: 'delete', item: payment });

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: this.deleteText.notify.title,
                text: this.deleteText.notify.content,
            });

            const $datatable = this.$refs.datatable as Datatable;
            $datatable.refresh();
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la suppression du paiement`
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }

    /**
     * Ant design considére null comme une string vide et donc masque le
     * placeholder, du coup il faut mettre à null, puis mettre à undefined
     */
    prescriberModel: string | undefined | null = null;

    @Watch('meta', { deep: true, immediate: true })
    onMeta() {
        if (this.meta.filters && this.meta.filters.prescriber) {
            this.prescriberModel = this.meta.filters.prescriber;
        } else {
            this.prescriberModel = undefined;
        }
    }

    @Watch('prescriberModel', { immediate: true })
    onPrescriberModel() {
        if (this.prescriberModel) {
            this.meta.filters.prescriber = this.prescriberModel;
        } else if (this.meta.filters) {
            this.meta.filters.prescriber = null;
        }
    }
}
